import { useQueryUser } from '@/hooks/query/useQueryUser';
import { type UserActivityAction } from '@heidi/schema/ml-scribe';

/**
 * Server-authoritative count for a `user_activity` bucket on the current user payload.
 */
export function useUserActivityActionCount(action: UserActivityAction) {
  return useQueryUser((user) => {
    const n = user?.user_activity?.[action];
    return typeof n === 'number' ? n : 0;
  });
}
